export const offerNotificationEventName = "event.offer_notification";
export const offerListNotificationEventName = "event.offer_list_notification";
export enum OfferNotificationAttribute {
    USER_ID = "user_id",
    VOIVODESHIP = "voivodeship",
    CITY = "city",
    DISTRICT = "district",
    ROOMS = "selected_rooms",
    PHONE_NUMBER = "phone_number",
    PHONE_MARKETING_CONSENT = "zgoda_marketingowa_sms",
    EMAIL_MARKETING_CONSENT = "zgoda_marketingowa_email",
    WHATSAPP_MARKETING_CONSENT = "zgoda_marketingowa_whatsapp",
    PRICE = "price_range",
    PRICE_LOWER_LIMIT = "price_lower_limit",
    PRICE_UPPER_LIMIT = "price_upper_limit"
}
export const offerNotificationEventName = "event.offer_notification";
export const offerListNotificationEventName = "event.offer_list_notification";
export enum OfferNotificationAttribute {
    USER_ID = "user_id",
    VOIVODESHIP = "voivodeship",
    CITY = "city",
    DISTRICT = "district",
    ROOMS = "selected_rooms",
    PHONE_NUMBER = "phone_number",
    PHONE_MARKETING_CONSENT = "zgoda_marketingowa_sms",
    EMAIL_MARKETING_CONSENT = "zgoda_marketingowa_email",
    WHATSAPP_MARKETING_CONSENT = "zgoda_marketingowa_whatsapp",
    PRICE = "price_range",
    PRICE_LOWER_LIMIT = "price_lower_limit",
    PRICE_UPPER_LIMIT = "price_upper_limit"
}
